"use client";
import React from "react";
import { GetList } from "../../../hook/getList.tsx";
import CategoryItem from "./CategoryItem.tsx";

const ListCategoryFrame = () => {
  const { data: response } = GetList<any>({
    url: "frame/get-list-category",
  });
  
  // console.log(response);
  
  const listCategory = response || [];

  const renderCategory = (item: any, index: number) => {
    return <CategoryItem key={index} item={item} index={index} />;
  };
  
  return (
    <div className="px-10">
      <div className="text-center font-bold text-[pink] text-2xl mb-6">
        Danh mục Frame
      </div>
      <div className="mt-4 max-w-6xl mx-auto w-full px-2">
        {listCategory && listCategory.length > 0 ? (
          <div className="rounded-2xl border-[pink]/40 bg-white/40 backdrop-blur p-4">
            
            <div className="flex flex-col gap-3">
              {listCategory.map(renderCategory)}
            </div>
          </div>
        ) : (
          <div className="text-center text-gray-500 mt-4 py-10">
            {listCategory ? "Không có dữ liệu" : "Đang tải..."}
          </div>
        )}
      </div>
    </div>
  );
};

export default ListCategoryFrame;
